import Image from 'next/image';
import cn from 'classnames';

import Link from '@/components/link';
import Button from '@/components/Button';

type ResourceCardProps = {
  href: string;
  cta: string;
  title: string;
  description: string;
  color: string;
  image: StaticImageData;
};

export default function ResourceCard({
  href,
  color,
  title,
  description,
  image,
  cta,
}: ResourceCardProps) {
  return (
    <Link
      href={href}
      key={href}
      className={cn(
        `grid h-full w-full rounded-lg py-6 px-5 text-whisper transition-colors`,
        color,
      )}
    >
      <div>
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="mt-2 text-xs font-medium">{description}</p>
        <Button
          withArrow
          appearance="minimal"
          colour="whisper"
          size="small"
          className="mt-3 text-xs font-semibold leading-3"
        >
          {cta}
        </Button>
      </div>
      <div className="mt-6">
        <Image
          src={image}
          layout="responsive"
          width={226}
          height={157}
          alt={title}
          objectFit="contain"
        />
      </div>
    </Link>
  );
}
